import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuItemComponent } from './menuItem.component';
import { PlIconModule } from '@app/icon-library/lib/pl-icon.module';

@NgModule({
  imports: [CommonModule, PlIconModule],
  declarations: [MenuItemComponent],
  exports: [MenuItemComponent],
})
export class MenuItemModule {}
